import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import DynamicForm from "../../../../../data/Axios/DynamicForm";
import { executeAnyMutation, fetchJsonDynamic } from "../../../../../data/DynamicServiceNew/jsondynamicservice";
import { customerservice, setupManagementUrl } from "../../../../../config";
import { nextOfKinFields } from "../../../../../data/DynamicForm/FormFields/CustomerFormFields";


 const base_url = customerservice.uri;
//const base_url = "https://localhost:7048/graphql/"
const setup_url = setupManagementUrl.uri;

const NOKForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const customerId= parseInt(localStorage.getItem("CustomerId"))
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [rightsData, setRightsData] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [maritalStatusData, setMaritalStatustData] = useState([]);
  const [relationData, setRelationData] = useState([]);


  useEffect(() => {
    async function fetchAllData() {
      try {
        const maritalStatusDataResponse = await fetchJsonDynamic(
          "allMaritalStatus",
          null,
          null,
          setup_url
        );
        const RelationDataResponse = await fetchJsonDynamic(
          "allCustomerRelationships",
          null,
          null,
          setup_url
        );
        if (RelationDataResponse?.results) {
          const results = JSON.parse(RelationDataResponse?.results);
          setRelationData(results || []);
        }
        if (maritalStatusDataResponse?.results) {
          const results = JSON.parse(maritalStatusDataResponse?.results);
          setMaritalStatustData(results || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);
 const maritalStatusOptions = maritalStatusData.map((status) => ({
    value: status.Id,
    label: status.Name,
  }));
  const relationOptions = relationData.map((status) => ({
    value: status.Id,
    label: status.Name,
  }));

  const formatDate = (date) => {
    if (!date) return null; // Handle null or undefined dates
    return date.split("T")[0]; // Extract the date part
  };
  const initialValues = {
    id: props.data ? props.data.Id : "",
    nextOfKinRelationshipId: props.data ? props.data.NextOfKinRelationshipId : "",
    firstName: props.data ? props.data.FirstName : "",
    otherNames: props.data ? props.data.OtherNames : "",
    nextOfKinMobileNumber: props.data ? props.data.NextOfKinMobileNumber : "",
    idNoOrPassport: props.data ? props.data.IdNoOrPassport : "",
    maritalStatus: props.data ? props.data.MaritalStatus : "",
    dob: props.data ? formatDate(props.data.Dob) : "",
    currentResidence: props.data ? props.data.CurrentResidence : "",
    permanentResidence: props.data ? props.data.PermanentResidence: "",
    town: props.data ? props.data.Town : "",
    houseName: props.data ? props.data.HouseName : "",
    floorNumber: props.data ? props.data.FloorNumber : "",
    roomNumber: props.data ? props.data.RoomNumber : "",
    occupation: props.data ? props.data.Occupation : "",

  };

  // const checkNokDuplicate = async (fieldName, value, setFieldError) => {
  //   const term = value ? value.trim() : "";
  //   if (!term) {
  //     setFieldError(fieldName, undefined);
  //     return;
  //   }
  //   try {
  //     const variables = { [fieldName]: term };
  //     if (props.isEditing && props.data?.Id) {
  //       variables.id = props.data.Id;
  //     }
  //     const response = await fetchJsonDynamic(
  //       "nextOfKinDuplicateCheck",
  //       "nextOfKin",
  //       variables,
  //       base_url
  //     );
  //     if (response?.results) {
  //       const parsed = JSON.parse(response.results);
  //       setFieldError(fieldName, parsed?.exists ? parsed.message : undefined);
  //     }
  //   } catch (error) {
  //     console.error(`Error checking duplicate for ${fieldName}:`, error);
  //   }
  // };
  const checkNokDuplicate = async (fieldName, value, setFieldError) => {
  const term = value ? value.trim() : "";
  if (!term) {
    setFieldError(fieldName, undefined);
    return;
  }
  try {
    const variables = { [fieldName]: term, customerId };
    if (props.isEditing && props.data?.Id) {
      variables.id = props.data.Id;
    }
    const response = await fetchJsonDynamic(
      "nextOfKinDuplicateCheck",
      "nextOfKin",
      variables,
      base_url
    );
    if (response?.results) {
      const parsed = JSON.parse(response.results);
      setFieldError(fieldName, parsed?.exists ? parsed.message : undefined);
    }
  } catch (error) {
    console.error(`Error checking duplicate for ${fieldName}:`, error);
  }
};

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      const {
        nextOfKinRelationshipId,
        firstName,
        otherNames,
        nextOfKinMobileNumber,
        idNoOrPassport,
        maritalStatus,
        dob,
        currentResidence,
        permanentResidence,
        town,
        houseName,
        floorNumber,
        roomNumber,
        occupation,
    
      } = values;

      const mutationData = {
        //id: props.data.Id,
        nextOfKinRelationshipId:parseInt(nextOfKinRelationshipId),
        firstName,
        otherNames,
        nextOfKinMobileNumber,
        idNoOrPassport,
        maritalStatus:parseInt(maritalStatus),
        dob,
        currentResidence,
        permanentResidence,
        town,
        houseName,
        floorNumber,
        roomNumber,
        occupation,
        customerId,
       
      };

      if (props.isEditing) {
        mutationData.id = props.data.Id;
      }

      const response = await executeAnyMutation(
        props.isEditing ? "updateNextOfKin" : "createNextOfKin",
        mutationData,
        "nextOfKin",
        false,
        base_url
      );

      if (response.results) {
        props.onClose();
        props.onAction();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `NOK${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }else if (response.error) {
            
        let errorMessage = "An unknown error occurred.";
      
        try {
          // Check if response.error is a JSON string and parse it
          const errorObj = typeof response.error === "string" ? JSON.parse(response.error) : response.error;
      
          // Handle different error structures
          if (typeof errorObj === "string") {
            errorMessage = errorObj; // Direct string message
          } else if (errorObj?.error) {
            errorMessage = errorObj.error; // JSON object with 'error' key
          } else if (errorObj?.Error) {
            errorMessage = errorObj.Error.match(/System\.Exception: (.*?)\./)?.[1] || errorObj.Error;
          }
        } catch (err) {
          props.onClose();
          // If parsing fails, fallback to the raw error string
          errorMessage = response.error;
        }

        if (errorMessage.includes("already registered to customer")) {
          const fieldName = errorMessage.startsWith("Mobile Number")
            ? "nextOfKinMobileNumber"
            : "idNoOrPassport";
          setFieldError(fieldName, errorMessage);
          setSubmitting(false);
          return;
        }

            Swal.fire({
              icon: "error",
              title: "Error!",
               text: errorMessage || "An error occurred while processing your request.",
            });
          }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };
  useEffect(() => {
    async function fetchAllData() {
      try {
        const maritalstatus = await fetchJsonDynamic(
          "allMaritalStatus",
          null,
          null,
          setupManagementUrl.uri
        );
      
        
        if (maritalstatus?.results) {
            const results = JSON.parse(maritalstatus?.results);
            setMaritalStatus(results || []);
          }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchAllData();
  }, []);

  // const forms =[
  //   ...nextOfKinFields,
  
  //     {
  //       name: "maritalStatus",
  //       label: "Marital Status",
  //       type: "select", 
  //       options: maritalStatusOptions,
  //       gridColumn: "span 2",
  //       required: false,
  //     },
    
  // ]
  const fields = [
    {
      name: "nextOfKinRelationshipId",
      label: "Relationship",
      type: "select",
      options: relationOptions,
      gridColumn: "span 2",
      required: false,
    },
    {
      name: "maritalStatus",
      label: "Marital Status",
      type: "select",
      options: maritalStatusOptions,
      gridColumn: "span 2",
      required: false,
    },
    ...nextOfKinFields.map((f) =>
      ["idNoOrPassport", "nextOfKinMobileNumber"].includes(f.name)
        ? {
            ...f,
            onBlur: (e, setFieldValue, values, setFieldError) => {
              checkNokDuplicate(f.name, e.target.value, setFieldError);
            },
          }
        : f
    ),
  ];

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit NOK" : "Create NOK"}
      subtitle={
        props.isEditing
          ? "Edit an Existing NOK"
          : "Create a NOK"
      }
    />
  );
};

export default NOKForm;
